import { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Button, Table, Form } from "react-bootstrap";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {
  ContenedorTitulo,
  Main,
  ContenedorFecha,
  ContenedorEditar
} from "../Usuario Cuentas/UsuariosElements";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

const EditOrganizacion = () => {
  const history = useHistory();
  const query = new URLSearchParams(useLocation().search);
  const id = query.get("org");
  const getEdit = query.get("edit");
  const isEdit = (getEdit === "true");

  const [organizaciones, setOrganizaciones] = useState([{ nombre: "", direccion: "", telefono: "" }]);
  const [tiempo, setTiempo] = useState("")
  const [duracion, setDuracion] = useState(0)
  const [usuario, setUsuario] = useState("")
  const [telefono, setTelefono] = useState("")
  const [facturacion, setFacturacion] = useState("")

  useEffect(() => {
    if (isEdit) {
      // Simula carga de varias organizaciones
      setOrganizaciones([
        { nombre: "Organización A", direccion: "Av. Siempre Viva 1", telefono: "555-1111" },
        { nombre: "Organización B", direccion: "Calle 2", telefono: "555-2222" }
      ]);
      setFacturacion("semestral")
      setUsuario("Gustavo")
      setTiempo("meses")
      setTelefono("+593999066187")
      setDuracion(6)
    }
  }, [isEdit]);

  const handleChange = (index, field, value) => {
    const newOrganizaciones = [...organizaciones];
    newOrganizaciones[index][field] = value;
    setOrganizaciones(newOrganizaciones);
  };

  const handleAddRow = () => {
    setOrganizaciones([...organizaciones, { nombre: "", direccion: "", telefono: "" }]);
  };

  const handleRemoveRow = (index) => {
    const newOrganizaciones = [...organizaciones];
    newOrganizaciones.splice(index, 1);
    setOrganizaciones(newOrganizaciones);
  };

  const handleGuardar = () => {
    // Aquí enviarías todas las organizaciones a tu backend
    console.log("Organizaciones guardadas:", organizaciones);
    alert("Organizaciones guardadas con éxito");
  };

  return (
    <Main>
      <ContenedorFecha>
        <Button onClick={() => history.goBack()}>Atrás</Button>
      </ContenedorFecha>

      <ContenedorTitulo>
        {isEdit ? "Editar Organizaciones" : "Crear Organizaciones"}
      </ContenedorTitulo>

      <div style={{ gap: '1rem', display: 'flex', flexDirection: 'column', marginTop: '1rem', marginBottom: '1rem' }}>
        
        <ContenedorEditar>
          <TextField
            id="outlined-disabled"
            label="Usuario"
            type="text"
            value={usuario}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(e) => setUsuario(e.target.value)}
          />
        </ContenedorEditar>
        <div style={{ width: '14rem' }}>
          <TextField
            label="Duración contrato"
            type="number"
            value={duracion}
            onChange={(e) => setDuracion(e.target.value)}
            fullWidth
            inputProps={{ min: 1 }}
          />
        </div>
        <div style={{ width: '14rem' }}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Tiempo</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              defaultValue={tiempo}
              label="Tiempo"
              onChange={(e) => setTiempo(e.target.value)}
            >

              <MenuItem value="meses">Meses</MenuItem>
              <MenuItem value="anios">Años</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>

   
    </Main>
  );
};

export default EditOrganizacion;
